/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceTicketFilters {
    getFixupPrototypeFunction() { return FreshserviceTicketFilters.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceTicketFilters>): FreshserviceTicketFilters {
        let obj = Object.assign(new FreshserviceTicketFilters(), model);
        FreshserviceTicketFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceTicketFilters>): FreshserviceTicketFilters {
        if (!model) return null;
        return FreshserviceTicketFilters.newInstance(<FreshserviceTicketFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceTicketFilters) {
        if (!obj) return;

        models.FreshserviceTicketFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceTicketFilters): boolean {
        Object.setPrototypeOf(obj, FreshserviceTicketFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    status: Array<models.FreshserviceTicketStatus>;

    priority: Array<models.FreshserviceTicketPriority>;

    department_id: Array<number>;

    /**
     * specify the start date
     */
    start_date: Date;

    /**
     * specify the end date
     */
    end_date: Date;

}
